<template>
  <section ref="container" class="text-center indexContainer">
    <HomeBanner
      :is-mobile="isMobile"
      :d-industry="industry"
      :d-jobfunction="jobfunction"
    />
    <template v-if="isMobile">
    <SearchInput :d-industry="industry" :d-jobfunction="jobfunction" />
    </template>
    <div ref="featurejob" class="featured-job-list pb-0 pb-md-4 mt-5">
      <div class="bg-mask">
        <div class="container">
          <div class="cp-hp-title">
            {{ cpLang("global.featured_job") }}
          </div>
          <FeaturedJobs :items="featuredJob" />
        </div>
      </div>
    </div>
    <RecommendCompany :is-login="login" />
    <div class="featured-logo-list">
      <div class="container">
        <FeatureLogo :data="logoList" />
      </div>
    </div>
    <div class="community">
      <div class="cp-hp-title mb-3">
        {{ cpLang('footer.community') }}
      </div>
      <span v-html="cpLang('homepage.commuity_desc')" class="communities-desc" />
      <Communities :community-card="communityCard" />
    </div>
    <div class="future">
      <div class="container">
        <h4 class="text-dark">
          {{ cpLang('homepage.future') }}
        </h4>
        <div class="row over-unset">
          <div class="input-wrap">
            <div class="col-xs-12 col-md-9 col-lg-10 input-col">
              <SearchBox redirect second-box />
            </div>
            <div class="col-xs-12 col-md-3 col-lg-2">
              <div
               @click="goSearch"
               class="search-btn"
              >
                {{ cpLang("global.search") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AlertPop />
  </section>
</template>

<script>
// import Staticbanner from '@/components/global/Staticbanner'
import SearchBox from '@/components/search/SearchBox'
import RecommendCompany from '../components/index/RecommendCompany.vue'
import HomeBanner from '~/components/index/HomeBanner'
// import IndustryList from '~/components/index/IndustryList'
// import FunctionList from '~/components/index/FunctionList'
// import CareerHubs from '~/components/index/CareerHubs'
// import CareerHubsBlock from '~/components/index/CareerHubsBlock'
// import AdsBox from '~/components/global/AdsBox'
import FeatureLogo from '~/components/index/FeatureLogo'
import FeaturedJobs from '~/components/index/FeaturedJobs'
import Communities from '~/components/index/Communities'
import AlertPop from '~/components/global/AlertPop'
import commonFunc from '~/assets/js/commonHelper.js'
import SearchInput from '~/components/index/SearchInput.vue'

export default {
  components: {
    // FunctionList,
    // IndustryList,
    // AdsBox,
    // CareerHubs,
    // CareerHubsBlock,
    // Staticbanner,
    RecommendCompany,
    FeatureLogo,
    FeaturedJobs,
    Communities,
    SearchBox,
    SearchInput,
    HomeBanner,
    AlertPop
  },
  data: function () {
    return {
      sectionBtn: 'Explore Now',
      sectionTitle: 'Career Development',
      sectionSubTitle: 'GetLinks creates opportunites for you to develop your career through different digital technology industries and sectors',
      logoList: null,
      productList: null,
      careerHubs: null,
      featuredJob: null,
      showTab: 'fun',
      isMobile: false,
      showCareerHub: false,
      items: [
        {
          img: 'Group906.svg',
          title: 'Career GPS',
          desc: `Career GPS is a free and useful online tool
          provide you with a personalized career
          analysis, insights and market intelligence
          for self-assessment, career planning and
          development.`,
          redirectUrl: 'https://www.cpjobs.com/hk/gps',
          targetBlank: true
        },
        {
          img: 'Group914.svg',
          title: 'Career Development',
          desc: `GetLinks creates opportunites for you to
          develop your career through different
          digital technology industries and sectors.
          `,
          redirectUrl: '/career-development'
        },
        {
          img: 'Group922.svg',
          title: 'Skills Training',
          desc: `Are you ready to embark your career in
          Innovation and Technology?
          `,
          redirectUrl: '/skills-training'
        },
        {
          img: 'Group926.svg',
          title: 'Career Advice',
          desc: `Need advice? Tips to get you ready and
            steady`,
          redirectUrl: '/career-advice'
        }
      ],
      communityCard: [
        {
          title: this.cpLang('homepage.card_title1'),
          desc: this.cpLang('homepage.card_desc1'),
          url: 'https://getlinks.co/events/',
          classname: 'home-ccard-1'
        },
        {
          title: this.cpLang('homepage.card_title2'),
          desc: this.cpLang('homepage.card_desc2'),
          url: 'https://humansoftech.getlinks.co/',
          classname: 'home-ccard-2'
        },
        {
          title: this.cpLang('homepage.card_title3'),
          desc: this.cpLang('homepage.card_desc3'),
          url: 'blog',
          classname: 'home-ccard-3',
          internal: true
        }
      ]
    }
  },
  computed: {
    login: function() {
      return this.$auth.loggedIn
    },
    swiperOptions() {
      return {
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            centeredSlides: true

          },
          768: {
            slidesPerView: 3
          }
        }
      }
    }
  },
  async asyncData(ctx) {
    // Get Feature Logo
    const {
      req,
      store
    } = ctx
    const url = req === undefined ? '/' : req.url
    await store.dispatch('search/fetchSeo', url)
    await store.dispatch('homepage/fetchFeaturedLogo')
    await store.dispatch('homepage/fetchFeaturedJob')
    await store.dispatch('homepage/fetchFilterData')
    await store.dispatch('homepage/fetchCareerHubs')
    await store.dispatch('homepage/fetchProductList')
    const jobFilter = JSON.parse(JSON.stringify(store.state.homepage.filter))
    const {
      industry,
      jobfunction
    } = jobFilter.filter
    const {
      careerHubs,
      featuredLogo,
      productList,
      featuredJob
    } = store.state.homepage
    // filter empty industry
    const filteredIndustry = []
    for (const i in industry) {
      if (industry[i].count) {
        filteredIndustry.push(industry[i])
      }
    }
    const filteredFunction = []
    for (const i in jobfunction) {
      if (jobfunction[i].count) {
        const childs = []
        for (const j in jobfunction[i].sub) {
          if (jobfunction[i].sub[j].count) {
            childs.push(jobfunction[i].sub[j])
          }
        }
        jobfunction[i].sub = childs
        filteredFunction.push(jobfunction[i])
      }
    }
    // console.log(filteredFunction)
    return {
      logoList: featuredLogo,
      industry: filteredIndustry,
      jobfunction: filteredFunction,
      careerHubs,
      featuredJob,
      productList,
      seo: store.state.search.seo
    }
    // return { logoList: splitEvery(6, result) }
  },
  head() {
    return {
      title: this.seo.title,
      meta: [
        { hid: 'keywords', name: 'keywords', content: this.seo.metakeyword },
        { hid: 'description', name: 'description', content: this.seo.desc }
      ],
      bodyAttrs: {
        id: 'home-page'
      }
      // script: [
      //   { src: '/asset/swiper.min.js' }
      // ]
    }
  },
  mounted() {
    const vm = this
    this.updateWidth()
    // console.log(this.$auth.$state)
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        document.querySelector('#cp-search-nav').classList.add('active')
      } else {
        document.querySelector('#cp-search-nav').classList.remove('active')
      }
    })
    window.addEventListener('resize', function () {
      vm.updateWidth()
      if (vm.$refs.ch) vm.$refs.ch.reload()
    })
  },
  methods: {
    updateWidth: function () {
      if (process.client) {
        this.isMobile = commonFunc.isPortraitMobile()
      }
    },
    goSearch: function(e) {
      const val = document.querySelector('#secondKeyword').value
      window.location = '/SearchJobs?keyword=' + val
    }
  }
}

</script>

<style lang="scss">

  .partners{
    li{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
  }
  .tech-partners{
    li{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      img{
        max-height: 38px;
      }
    }
    li{
      &:nth-child(3){
        img{
          max-height: 27px;
        }
      }
    }
  }
  .it-wh-title{
    color: #fff;
    font-size: 16px;
  }
  .cp-hp-title {
    color: #141E32;
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
    &.text-white{
      font-size: 22px;
    }
  }
  .cp-hp_careerhub {
    background: #163D5D;
    img {
      max-width: 100%;
    }
  }
  .itemLogo {
    width: 100%;
    min-height: 50px;

    &.gps {
      max-width: 210px;
    }

    &.cv {
      max-width: 305px;
      margin-top: 50px !important;
    }
  }
  .co-img{
    max-height: 70px;
  }
  .enquiry-contact{
    h2{
      color: #003979;
      font-size: 14px;
      font-weight: bold;
    }
    a{
      font-size: 14px;
    }
    .col-body{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: left;
    }
    .icon-img{
      max-width: 20px;
      margin-right: 10px;
    }
  }
  .ur-success{
    background: #f0f0f0;
    h3{
      color: #333333;
      font-size: 14px;
      font-weight: bold;
      margin: 0;
      padding: 10px;
    }
    span{
      font-size: 14px;
    }
    a{
      color: #fff;
      background: #2CB8F4;
      padding: 5px 17px;
      border-radius: 999px;
      font-size: 14px;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      height: 31px;
    }
    img{
      max-height: 41px;
    }
    .row{
      display: flex;
      .col-md-6{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-start;
        // height: 220px;
        height: 180px;
        position: relative;
      }
    }
    .l-flex{
      &.w-100{
        align-items: center;
        justify-content: center;
        padding: 5px;
      }
    }
  }
  .simple-title{
    font-size: 14px;
    color: #003979;
  }
  .companies-insterested{
    padding-top:50px;
  }
  .featured-logo-list{
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .future{
    max-width: 100% !important;
    background: #F0F3F8;
    padding: 50px 0;
    .container{
      max-width: 50%;
    }
    h4{
      font-size: 22px;
      font-weight: bold;
      padding-bottom: 15px;
    }
    #search-box{
      z-index: 100 !important;
    }
  }
  .home-company-card{
    display: flex;
    flex-wrap: wrap;
    border: 2px solid #E6EAF0;
    margin-top: 30px;
    border-radius: 20px;
    box-shadow: 2px 2px 6px #00000029;
    height: auto;
    >div{
      padding: 20px 30px;
      display:flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .col-sm-8{
      display: flex;
      flex-wrap: wrap;
      flex-flow: column;
      border-left:2px solid #E6EAF0;
      align-items: baseline;
      .cp-card-title{
        color: #0081BE;
        font-size:16px;
        font-weight: 700;
      }
      .cp-card-tag{
        small{
          font-size: 10px;
          color: #707070;
        }
      }
      .cp-card-desc{
        font-size: 14px;
      }
    }
  }
</style>
